<template>
  <div  style='overflow-y: hidden;
      overflow-x: hidden;'>
    <locationSearch ref="locationSearch" @clicked="changedLocationInput" :prefix="'location.' + treeID" :aggregations="locationFacets" :setLocations="setLocationsLocal" :locationsPreSet="locations">
    </locationSearch>
    <div>
      <v-card-title class="pb-1 mb-2 mx-3" style="border-bottom: 1px dashed #666;">Annotations</v-card-title>
        <v-text-field
          v-model="search"
          label="Search Iconography Tree"
          hide-details
          clearable
          clear-icon="mdi-close-circle-outline"
        >
        </v-text-field>
        <v-treeview
        :item-key="'id'"
        :open.sync="openedLeaves"
        id="annoTree"
        selection-type="leaf"
        :filter="filter"
        :search="search"
        return-object
        v-model="localIcoSelected"
        rounded
        selectable
        hoverable
        :items="filteredIcoAnnos"
        dense
        multiple-active
        :active="icoActivated"
      >
        <template v-if="renderVRMode" v-slot:prepend="{ item }">
        <input
          type="checkbox"

          class="native-checkbox"
          :checked="isItemSelected(item)"
          @change="clickAnno(item)"
        />
      </template>
        <template class="v-treeview-node__label" slot="label" slot-scope="{ item }">
          <a :id="treeID"  @click="clickAnno(item)" @mouseover="mouseOverNode(item)" @mouseleave="mouseLeaveNode(item)">

            <div class="v-treeview-node__label" style="white-space: wrap !important;">
              {{ item.name }}
              <v-badge
                :content="getCount(item)"
                inline
                color="primary"
                ref="badge"
              >
              </v-badge>
            </div>
          </a> <a :href="getIconographyLink(item)">[go to]</a>
        </template>
      </v-treeview>
    </div>
</div>
</template>
<script>
import locationSearch from '@/components/locationSearch.vue'

export default {
  name: 'Cave3DModelFilterPanel',
  components: {
    locationSearch
  },
  props: {
    renderVRMode: {
      type: Boolean,
      default: false
    },
    setLocations:Function,
    locations:{
      type: Array,
      default: function () {
        return []
      },
    },
    updateicoSelectedParent:Function,
    prepLocationAggs: Function,
    changedLocationInput: Function,
    annoPrCount: {
      type: Object,
      default: function () {
        return {}
      },
    },
    locationFacets: {
      type: Array,
      default: function () {
        return []
      },
    },
    search: null,
    treeID: "",
    relatedDepictions: {
      type: Array,
      default: function () {
        return []
      },
    },
    icoAnnos: {
      type: Array,
      default: function () {
        return []
      },
    },
    annoPreSelected: {
      type: Array,
      default: function () {
        return []
      },
    },
    hoveredIcos: {
      type: Array,
      default: function () {
        return []
      },
    }
  },
  data () {

    return {
      annotationsByWall: {},
      cave3DInfForWalls: {},
      icoActivated: [],
      selectedDepictions:[],
      filteredIcoAnnos:[],
      openedLeaves:[],
      localIcoSelected: []
    }
  },
  computed: {
    icoSelected:{
      get: function(){
        return  this.annoPreSelected;
      },
      set: function (newValue){
        if (JSON.stringify(newValue) !== JSON.stringify(this.annoPreSelected)) {
          this.updateicoSelectedParent(newValue)
        }
      }
    },
    filter () {
      return  (item, search, textKey) => {
        if (item.search) {
          // .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          return (item["search"].toLowerCase().normalize("NFD").indexOf(search) > -1 || item["name"].toLowerCase().normalize("NFD").indexOf(search) > -1)
        } else {
          return (item["name"].toLowerCase().normalize("NFD").indexOf(search) > -1)
        }
      }
    },
    iconographyById() {
      return this.indexIconographyTree(this.filteredIcoAnnos)
    }
  },
  methods: {
    indexIconographyTree(nodes, map = new Map()) {
      nodes.forEach(node => {
        if (node?.iconographyID) {
          map.set(node.iconographyID, node)
        }

        if (node.children?.length) {
          this.indexIconographyTree(node.children, map)
        }
      })

      return map
    },

  // Hilfsfunktion: Rekursiv IDs einsammeln
    collectAllIDs(nodes, acc = []) {
      for (const node of nodes) {
        acc.push(node) // oder iconographyID, wenn das deine `item-key` ist
        if (node.children && node.children.length > 0) {
          this.collectAllIDs(node.children, acc)
        }
      }
      return acc
    },
    isItemSelected(item) {
      return this.icoSelected.find(i => i.id === item.id)
    },
    setLocationsLocal(newValue){
      console.log("changed location input!!!!!! filtertree");
      this.initFilteredIcoAnnos()
      this.setLocations(newValue)
    },
    initFilteredIcoAnnos() {
      console.log("icoSelected renewing filtertree icoannos", this.icoAnnos);

      this.filteredIcoAnnos = []
      // Rekursiver Filter zum Entfernen von Knoten, die die Eigenschaft hide:true haben
      const filterTree = (nodes) => {
        return nodes
          .filter(node => {
            console.log("filtertree", node.name, this.annoPrCount[node.iconographyID], this.annoPrCount[node.iconographyID] > 0);

            return this.annoPrCount[node.iconographyID] > 0
          }) // Filtere ausgeblendete Knoten
          .map(node => {
            // Wenn der Knoten Kinder hat, filtere diese ebenfalls rekursiv
            if (node.children) {
              return { ...node, children: filterTree(node.children) };
            }
            return node;
          });
      };
      console.log("filtertree", filterTree(this.icoAnnos));

      this.filteredIcoAnnos = filterTree(this.icoAnnos);
      this.openedLeaves = this.collectAllIDs(this.filteredIcoAnnos)
      this.$log.debug("openedLeaves", this.openedLeaves);
    },
    getCount(item){

      return this.annoPrCount[item.iconographyID]
    },
    prepSearch(){
      this.$refs.locationSearch.prepSearch()
    },
    switchShowTree(){
      this.showTree = !this.showTree
      const _self = this
      setTimeout(function(){ _self.onWindowResize()}, 50);


    },
    getIconographyLink(item){
      return window.location.origin  + "/iconography/" + item.id
    },
    onSelect(selected){
      console.log("onSelect", selected);

      this.updateicoSelectedParent(selected)
      this.initFilteredIcoAnnos()

    },
    clickAnno(item){
      console.log("click anno");

      let found = false
      let filteredAnnos = []
      for (let anno of this.icoSelected){
        if (anno.id === item.id){
          found = true
        } else {
          filteredAnnos.push(anno)
        }
      }
      if (found) {
        this.icoSelected = filteredAnnos
      } else {
        this.icoSelected.push(item)
      }
      this.initFilteredIcoAnnos()
    },
    mouseOverNode(item){
      console.log("blubb");


    },
    mouseLeaveNode(item){
    }
  },
  watch: {
    locations: {
      handler(val){


        this.changedLocationInput()
        this.initFilteredIcoAnnos()
      },
      deep: true
    },
    annoPreSelected: {
      handler(val){
        console.log("annoPreSelected changed!", val, this.treeID);

        this.localIcoSelected = val
        this.initFilteredIcoAnnos()
      },
      deep: true
    },
    annoPreSelected: {
      immediate: true,
      handler(val) {

      }
    },
    localIcoSelected: {
      deep: true,
      handler(val) {
        this.updateicoSelectedParent(val)
      }
    },
    annoPrCount: {
      handler(val){
        console.log("annoPrCount changed!");
        this.initFilteredIcoAnnos()
      },
      deep: true
    },
    openedLeaves: {
      handler(val){
      },
      deep: true
    },
    icoAnnos: {
      handler(val){
        this.$log.debug("icoAnnos changed!");
        this.initFilteredIcoAnnos()
      },
      deep: true
    },
    hoveredIcos: {
      handler(val){
        this.icoActivated = val.map(id => this.iconographyById.get(id)).filter(Boolean)
        this.$log.debug("hoveredIcos changed!", this.icoActivated, val);
      },
      deep: true
    }
  },
  created () {
  },
  beforeDestroyed () {

  },
  beforeMount:function(){

  },
  mounted() {
    this.$log.debug("mounted filterpanel", this.treeID);
    this.initFilteredIcoAnnos()
  }
}
</script>

<style lang="css" >
  .color-box {
    width: 48px;
    height: 24px;
  }
.fake-checkbox {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  border: 1px solid #000;
  background-color: #fff;
  vertical-align: middle;
  position: relative;
}
.fake-checkbox.checked::after {
  content: "✓";
  position: absolute;
  top: -1px;
  left: 2px;
  font-size: 14px;
  color: black;
}
.tree-label {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: normal;
}

.native-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
</style>
